import _reject from 'lodash/reject';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import {z} from 'zod';
import getCardFromState from '../../utils/cardStateStorage/getCardFromState';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import setCardInState from '../../utils/cardStateStorage/setCardInState';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';

const deleteOutuputToolSchema = z.object({
  outputId: z.number().describe('The id of the output to delete').optional(),
  outputName: z.string().describe('The name of the output to delete').optional(),
});

export default function deleteOutuputTool() {
  async function execute(params: ToolExecuteParams<typeof deleteOutuputToolSchema>) {
    const {outputId, outputName} = params.input;

    if (!outputId && !outputName) {
      return toolResult('Either outputId or outputName must be provided');
    }

    const currentCard = getCardFromState();
    const currentOutputs = _reject(
      currentCard.outputs,
      (output) => output.id === outputId || output.name === outputName,
    );
    currentCard.outputs = currentOutputs;
    setCardInState(currentCard);

    return toolResult(JSON.stringify({status: 'success', message: 'Outputs deleted'}));
  }

  return tool({
    name: V2CardAgentToolName.DeleteOutput,
    description: 'Delete an output from a card',
    displayName: 'Deleting output',
    inputSchema: deleteOutuputToolSchema,
    execute,
  });
}
